setTimeout(() => {
  const swatches = document.getElementsByClassName("swatches__holder");
  for (let i = 0; i < swatches.length; i++) {
    swatches[i].addEventListener("click", getDiscountedPrice);
  }
}, 700);

function getDiscountedPrice() {
  var oldVariant = document.getElementsByClassName("axt-cp-custom")[1].getAttribute("axt-cp-variant-id");
  console.log("222222",oldVariant)
  setTimeout(() => {      
      // Remove old variant and product IDs
    document.getElementsByClassName("axt-cp-custom")[1].classList.remove(oldVariant);

    var variantId = document.querySelector('[name="id"]').value;
  console.log("3333333",variantId)
    // Add new variant and product IDs
    document.getElementsByClassName("axt-cp-custom")[1].classList.add(variantId);
    document.getElementsByClassName("axt-cp-custom")[1].setAttribute("axt-cp-variant-id", variantId);
  }, 700);
}